import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";

const ResignRegistration = ({ resignObj }) => {
  const [resignObjData, setResignObjData] = useState({});
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (resignObj) {
      setResignObjData(resignObj);
    }
  }, [resignObj]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setResignObjData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const resignHandleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting resignation:", resignObjData);
    if (tokenData) {
      try {
        setSubmitBtnLoading(true);
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/termination/resignEmp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify({
              regid: resignObjData.regid,
              terminationdt: resignObjData.date,
              reason: resignObjData.reason,
              createdby: resignObjData.createdby || 1,
            }),
          }
        );

        const data = await response.json();

        if (data.status) {
          setSubmitBtnLoading(false);
          Swal.fire({
            title: "Success",
            text: data.Message || "Resignation submitted successfully",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setSubmitBtnLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to submit resignation.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error submitting resignation:", error);
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "Network or server error. Please try again later.",
          icon: "error",
        });
      }
    }
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightResignReg {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightResignReg {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightResignReg {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightResignReg {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightResignReg {
            width:17% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightResignReg"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Resign Registration</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={resignHandleSubmit}>
            <div className="content">
              <div className="row">
                <div className="col-6">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={resignObjData?.UserName || ""}
                    readOnly
                  />
                </div>
                <div className="col-6">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Resignation Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={resignObjData.date || ""}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Reason
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Enter reason for resignation..."
                    name="reason"
                    value={resignObjData.reason || ""}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary ms-3"
                  disabled={submitBtnLoading}
                >
                  {submitBtnLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ResignRegistration.propTypes = {
  resignObj: PropTypes.object.isRequired,
};

export default ResignRegistration;
